// EstimateList.jsx  — PWA mobile estimate list
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { API_BASE_URL } from "../../Config/Config";

export default function EstimateList() {
  const navigate = useNavigate();
  const [estimates, setEstimates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    const fetchEstimates = async () => {
      try {
        const raw =
          sessionStorage.getItem("MisUserDetails") ||
          localStorage.getItem("MisUserDetails");
        if (!raw) {
          navigate("/");
          return;
        }
        const { OrgId, StoreId, UserId } = JSON.parse(raw);

        const params = new URLSearchParams({ OrgId, StoreId, UserId });
        const res = await fetch(
          `${API_BASE_URL}Billing/getEstimates?${params}`,
        );
        const data = await res.json();
        if (data?.Status && Array.isArray(data.ResultData)) {
          setEstimates(data.ResultData);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchEstimates();
  }, [navigate]);

  const getStatusBadge = (status) => {
    if (status === 1) return <span className="badge bg-success">Active</span>;
    return <span className="badge bg-secondary">Inactive</span>;
  };

  const filtered = estimates.filter((e) => {
    if (!searchText.trim()) return true;
    const s = searchText.toLowerCase();
    return (
      (e.BillNo || "").toLowerCase().includes(s) ||
      (e.Name || "").toLowerCase().includes(s) ||
      (e.Mobile || "").includes(s)
    );
  });

  if (loading) {
    return (
      <Base>
        <div className="text-center my-5 py-5">
          <div className="spinner-border text-primary" />
          <p className="mt-3 text-muted small">Loading estimates...</p>
        </div>
        <Footer />
      </Base>
    );
  }

  return (
    <Base>
      <div className="page-header">
        <div className="page-title">
          <h3>Estimates</h3>
          <h6>Select an estimate to review</h6>
        </div>
      </div>

      <div className="px-2 pb-5 mb-5">
        {/* Search */}
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search by name, bill no, mobile..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>

        {filtered.length === 0 ? (
          <div className="text-center py-5 text-muted">
            <i className="fa-solid fa-file-invoice fa-2x mb-2" />
            <p className="small mb-0">No estimates found.</p>
          </div>
        ) : (
          filtered.map((est) => (
            <div
              key={est.Id}
              className="card mb-3 shadow-sm"
              style={{ borderRadius: "12px", cursor: "pointer" }}
              onClick={() => navigate(`/quotationreview/${est.Id}`)}
            >
              <div className="card-body py-3 px-3">
                {/* Row 1 — name + status */}
                <div className="d-flex justify-content-between align-items-start mb-1">
                  <p className="fw-semibold mb-0" style={{ fontSize: "15px" }}>
                    {est.Name || "Walk-in"}
                  </p>
                  {/* {getStatusBadge(est.Status)} */}
                </div>

                {/* Row 2 — bill no + date */}
                <div className="d-flex justify-content-between mb-2">
                  <span className="text-muted small">
                    <i className="fa-solid fa-hashtag me-1" />
                    {est.BillNo}
                  </span>
                  <span className="text-muted small">
                    {est.QuotationDate
                      ? new Date(est.QuotationDate).toLocaleDateString("en-GB")
                      : "—"}
                  </span>
                </div>

                {/* Row 3 — mobile + type + total */}
                <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                  <span className="text-muted small">
                    <i className="fa-solid fa-phone me-1" />
                    {est.Mobile || "—"}
                  </span>
                  <div className="d-flex gap-2 align-items-center">
                    <span className="badge bg-light text-dark border d-none">
                      {est.PaymentType || "—"}
                    </span>
                    <span className="fw-semibold small text-success d-none">
                      ₹{parseFloat(est.Total || 0).toLocaleString()}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <Footer />
    </Base>
  );
}
